import React, { useContext, useState } from "react";
import TemplateCard from "./TemplateCard";
import { useTranslation } from "react-i18next";
import GlobalContext from "../GlobalContext";
import Debouncer from "./DebouncerUtility";
import BackendFactory from "../API/BackendFactory";
import { logout_sessionexpired } from "../logout";
import { IonButton, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonTitle } from "@ionic/react";
import { NewsListObject } from "../API/lib/JsonUtils";
import ErrorCard from "./ErrorCard";
import getFlavoriaLang from "../utils/flavoriaLang";

interface Props {
    language: string;
}

const deboucer = new Debouncer();
let jsonlang = "";

const NewsCards: React.FC<Props> = (props : Props) => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const [errorCode, setErrorCode] = useState("");
    const [newsjson, setnewsjson] = useState("");
    const globalContext = useContext(GlobalContext);

    deboucer.set_debouncer(() => {
        jsonlang = getFlavoriaLang(props.language);
        BackendFactory.getBackend()
          .getNewsFeed(jsonlang)
          .then((result) => {
            setnewsjson(result);
            setLoading(false);
          })
          .catch((reason) => {
            if (reason == "Expired Token") {
              logout_sessionexpired(globalContext, t);
            } else {
              if(typeof reason == "string")
                setErrorCode(reason)
              else
                setErrorCode("UnexpectedError");
    
              setLoading(false);
            }
          });
      });

      if(!loading && newsjson != "" && getFlavoriaLang(props.language) != jsonlang) {
        setLoading(true);
      }
    
      if (loading) {
        deboucer.call();
      }

    if (loading) {
      return (
        <div>
          <TemplateCard />
          <TemplateCard />
          <TemplateCard />
        </div>
      );
    } else if (errorCode != ""){
      return (<ErrorCard errorCode={errorCode}/>)
    } else {
      if (newsjson === "") {
        return (
          <IonCard>
            <IonCardHeader>
              <IonTitle>{t("No News to report currently.")}</IonTitle>
            </IonCardHeader>
          </IonCard>
        );
      } else {
        const news = new NewsListObject(newsjson);
        const list: Array<React.ReactElement> = news
          .getNewsItems()
          .map((article): React.ReactElement => {
            const date = new Date(article.date);
            const now = Date.now();
            const HIGHLIGHT_SEC = 30 * 24 * 60 * 60;
            const isRecent = date.getTime() >= now - HIGHLIGHT_SEC * 1000 && date.getTime() <= now;
            return (
              <IonCard key={article.key} style={isRecent ? { borderLeft: "4px solid var(--ion-color-success)" } : undefined}>
                <IonCardHeader>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", width: "100%", flexWrap: "wrap" }}>
                    <IonCardTitle>
                      <a href={article.link} target="_blank" rel="noopener noreferrer" style={{ color: "var(--ion-text-color)", textDecoration: "none" }}>
                        {article.title} &#x1F517;
                      </a>
                    </IonCardTitle>
                    <IonCardSubtitle style={{ whiteSpace: "nowrap" }}>{new Date(date).toLocaleDateString(props.language, { weekday: "short", year: "numeric", month: "numeric", day: "numeric" })}</IonCardSubtitle>
                  </div>
                </IonCardHeader>
                <IonCardContent>
                  <div
                    className="news-article"
                    style={{ color: "var(--ion-text-color)" }}
                    dangerouslySetInnerHTML={{ __html: article.text }}
                  />
                </IonCardContent>
              </IonCard>
            );
          });
        const archiveUrl =
          getFlavoriaLang(props.language) === "fi"
            ? "https://www.flavoria.fi/ajankohtaista/uutiset/"
            : "https://www.flavoria.fi/en/latest/news/";
        return (
          <div>
            {list}
            <div style={{ display: "flex", justifyContent: "flex-end", padding: "16px" }}>
              <IonButton fill="solid" href={archiveUrl} target="_blank" rel="noopener noreferrer">
                {t("View archived")}
              </IonButton>
            </div>
          </div>
        );
      }
    }
  }

export default NewsCards;